export const refetchTime = 3500